import { useTranslation } from 'react-i18next'

interface StubPanelProps {
  title: string
  placeholder: string
}

function StubPanel({ title, placeholder }: StubPanelProps): React.ReactElement {
  return (
    <div
      className="flex flex-col gap-2 rounded-lg border p-4"
      style={{ borderColor: 'var(--border)', background: 'var(--bg-card)' }}
    >
      <h3
        className="text-sm font-[var(--font-mono)] font-medium tracking-wide uppercase"
        style={{ color: 'var(--text)' }}
      >
        {title}
      </h3>
      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
        {placeholder}
      </p>
    </div>
  )
}

export function AiWorkbenchStub(): React.ReactElement {
  const { t } = useTranslation('analysis')

  return (
    <div className="flex flex-col gap-4 p-4">
      <h2
        className="text-lg font-semibold"
        style={{ color: 'var(--text)', fontFamily: 'var(--font-display, Syne, sans-serif)' }}
      >
        {t('aiWorkbench.title')}
      </h2>
      <div className="grid grid-cols-2 gap-4">
        <StubPanel
          title={t('aiWorkbench.chat.title')}
          placeholder={t('aiWorkbench.chat.placeholder')}
        />
        <StubPanel
          title={t('aiWorkbench.agentTasks.title')}
          placeholder={t('aiWorkbench.agentTasks.placeholder')}
        />
        <StubPanel
          title={t('aiWorkbench.findings.title')}
          placeholder={t('aiWorkbench.findings.placeholder')}
        />
        <StubPanel
          title={t('aiWorkbench.references.title')}
          placeholder={t('aiWorkbench.references.placeholder')}
        />
      </div>
      <StubPanel
        title={t('aiWorkbench.memory.title')}
        placeholder={t('aiWorkbench.memory.placeholder')}
      />
    </div>
  )
}
